import KeyFeaturesComponent from "@/components/keyFeatures";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const WhyOneMindComponent = () => {
  return <KeyFeaturesComponent {...WHY_ONEMIND_CONSTANTS} />;
};

export default WhyOneMindComponent;
